(function () {
  window.addEventListener('load', function () {
    var isContactTemplate =
      document.body.classList.contains('template-page') &&
      document.body.classList.contains('template-suffix-new-contact-us');

    if (isContactTemplate === false) {
      console.log('Not contact template. Chat script stopped.');
      return;
    } else {
      console.log('Contact template confirmed. Chat script active.');
    }

    document.addEventListener('click', function (e) {
      var chatLink = e.target.closest('a[href="https://www.mypatriotsupply.com/pages/contact-us#"]');

      if (chatLink !== null) {
        e.preventDefault();

        if (window.GorgiasChat && typeof window.GorgiasChat.open === 'function') {
          window.GorgiasChat.open();
        } else {
          console.log('GorgiasChat open function not available.');
        }
      } else {
        console.log('Clicked element is not the chat link.');
      }
    });
  });
})();